import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, euro } from "@/lib/api";
import { Check, Minus, Star } from "lucide-react";

const ROWS = [
  { key: "loulav", label: "Qualité du loulav" },
  { key: "etrog", label: "État de l'etrog" },
  { key: "hadassim", label: "Hadassim" },
];

export default function Compare() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then(({ data }) => setProducts(data)).catch(() => {}); }, []);

  const cell = (v) => {
    if (!v || v === "n.c.") return <span className="text-brand-green/40 flex items-center gap-1"><Minus className="w-4 h-4" /> n.c.</span>;
    if (v === "Coffret de présentation" || v === "Coffret premium")
      return <span className="inline-flex items-center gap-1.5 font-semibold text-[#9a6a1f]"><Check className="w-4 h-4 text-brand-gold" /> {v}</span>;
    return <span className="text-brand-green/85">{v}</span>;
  };

  return (
    <div className="brand-container py-14">
      <h1 className="font-serif text-4xl sm:text-5xl font-bold text-brand-green text-center mb-3">Comparatif des gammes</h1>
      <p className="text-center text-brand-green/60 mb-12">La caractéristique vedette : le coffret de présentation, à partir de l'Aleph.</p>

      <div className="hidden md:block bg-white rounded-2xl shadow-lg overflow-hidden">
        <table className="w-full text-sm" data-testid="compare-table">
          <thead>
            <tr>
              <th className="p-5 text-left w-48"></th>
              {products.map((p) => (
                <th key={p.gamme_key} className={`p-5 text-center ${p.featured ? "bg-brand-gold/10" : ""}`}>
                  <span className="rounded-full bg-brand-green text-white px-3 py-1 text-xs font-bold uppercase tracking-wider inline-flex items-center gap-1">
                    {p.featured && <Star className="w-3 h-3 text-brand-gold" />}{p.position_badge}
                  </span>
                  <div className="font-serif text-2xl font-bold text-brand-green mt-2">{p.name}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r) => (
              <tr key={r.key} className={`border-t border-brand-green/10 ${r.featured ? "bg-brand-gold/5" : ""}`}>
                <td className="p-5 font-semibold text-brand-green">{r.label}</td>
                {products.map((p) => (
                  <td key={p.gamme_key} className={`p-5 text-center ${p.featured ? "bg-brand-gold/5" : ""}`}>{cell(p.features?.[r.key])}</td>
                ))}
              </tr>
            ))}
            <tr className="border-t border-brand-green/10">
              <td className="p-5 font-semibold text-brand-green">Prix</td>
              {products.map((p) => (
                <td key={p.gamme_key} className={`p-5 text-center ${p.featured ? "bg-brand-gold/5" : ""}`}>
                  <div className="num text-2xl text-brand-green">{euro(p.price_ttc)}</div>
                  <div className="text-xs text-brand-green/50">TTC</div>
                </td>
              ))}
            </tr>
            <tr className="border-t border-brand-green/10">
              <td className="p-5"></td>
              {products.map((p) => (
                <td key={p.gamme_key} className="p-5 text-center">
                  <Link to={`/commander?gamme=${p.gamme_key}`} data-testid={`compare-reserve-${p.gamme_key}`} className="inline-block rounded-full bg-brand-gold text-brand-green px-6 py-2.5 font-bold hover:bg-brand-goldHover">Réserver</Link>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="md:hidden space-y-4">
        {products.map((p) => (
          <div key={p.gamme_key} className="bg-white rounded-2xl shadow p-5">
            <div className="flex items-center justify-between mb-3">
              <div>
                <span className="rounded-full bg-brand-green text-white px-3 py-1 text-xs font-bold uppercase">{p.position_badge}</span>
                <h3 className="font-serif text-2xl font-bold text-brand-green mt-2">{p.name}</h3>
              </div>
              <div className="text-right"><div className="num text-2xl text-brand-green">{euro(p.price_ttc)}</div></div>
            </div>
            {ROWS.map((r) => (
              <div key={r.key} className={`flex justify-between py-2 text-sm border-t border-brand-green/10 ${r.featured ? "bg-brand-gold/5 -mx-2 px-2 rounded" : ""}`}>
                <span className="text-brand-green/60">{r.label}</span>{cell(p.features?.[r.key])}
              </div>
            ))}
            <Link to={`/commander?gamme=${p.gamme_key}`} className="mt-4 block text-center rounded-full bg-brand-gold text-brand-green py-3 font-bold">Réserver</Link>
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mt-10">
        {products.map((p) => (
          <div key={p.gamme_key} className="bg-white rounded-2xl p-5 shadow-sm">
            <div className="text-xs uppercase tracking-widest text-brand-gold font-bold mb-1">Pour qui ?</div>
            <div className="font-serif text-lg font-bold text-brand-green mb-1">{p.name}</div>
            <p className="text-sm text-brand-green/70">{p.for_who}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
